import React, { useCallback } from 'react';
import { makeStyles, Box, AIIcon } from '@gogame/components';

import {
  createScreenRoute,
  Screen,
  withScreen,
  useLinkNavigate,
} from '@gogame/screens';
import { ChatProvider } from 'components/AIChatbot';

import { aiChatbotLink } from './navigation';
import { useChatId } from './hooks/useChatId';
import { ScreenChatContent } from './components/ScreenChatContent';

export const permission = 108;
const id = 66;

const screenReducer = (state) => state;

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  toolbar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
  },
  body: {
    background: theme.palette.background.paper,
    flex: 1,
    minHeight: 0,
  },
}));

const Scene = withScreen({
  name: 'ai-chatbot',
  reducer: screenReducer,
})(() => {
  const classes = useStyles();
  const chatId = useChatId();

  const goToChat = useLinkNavigate(aiChatbotLink);

  const handleChangeId = useCallback((newChatId) => {
    if (newChatId) {
      goToChat({ id: newChatId }, {});
    } else {
      goToChat({}, {});
    }
  }, []);

  return (
    <Box className={classes.root}>
      <Screen.Toolbar className={classes.toolbar} />
      <Screen.Body className={classes.body}>
        <ChatProvider id={chatId} onChangeId={handleChangeId}>
          <ScreenChatContent />
        </ChatProvider>
      </Screen.Body>
    </Box>
  );
});

export default createScreenRoute({
  title: 'Chat with AI Agent',
  icon: <AIIcon />,
  link: aiChatbotLink,
  screen: <Scene />,
  id: id,
  permission: permission,
});
